import apiService from '../../../services/api'

/**
 * Royale API Service
 * Работа с эндпоинтами /api/classic/*
 */

export const royaleApi = {
  /**
   * Получить активный раунд Royale
   * GET /api/classic/
   */
  getActiveRound: async (signal) => {
    try {
      const response = await apiService.makeRequest('/api/classic/', {
        method: 'GET',
        signal
      })
      return response
    } catch (error) {
      console.error('Ошибка получения активного раунда Royale:', error)
      throw error
    }
  },

  /**
   * Получить инвентарь и баланс для ставки
   * GET /api/classic/bet/
   */
  getBetInventory: async (signal) => {
    try {
      const response = await apiService.makeRequest('/api/classic/bet/', {
        method: 'GET',
        signal
      })
      return response
    } catch (error) {
      console.error('Ошибка получения инвентаря для ставки Royale:', error)
      throw error
    }
  },

  /**
   * Отправить ставку
   * POST /api/classic/bet/
   */
  placeBet: async ({ roundId, crystal, items }) => {
    try {
      const payload = {
        round_id: roundId
      }

      if (Number(crystal || 0) > 0) {
        payload.crystal = Number(crystal)
      }

      if (Array.isArray(items) && items.length > 0) {
        payload.items = items
      }

      const response = await apiService.makeRequest('/api/classic/bet/', {
        method: 'POST',
        body: JSON.stringify(payload)
      })

      if (response.error) {
        const error = new Error(response.error)
        error.message = response.error
        throw error
      }

      return response
    } catch (error) {
      console.error('Ошибка отправки ставки Royale:', error)
      throw error
    }
  },

  /**
   * Получить детали завершенного раунда
   * GET /api/classic/ID/
   */
  getRoundById: async (roundId) => {
    try {
      const response = await apiService.makeRequest(`/api/classic/${roundId}/`, {
        method: 'GET'
      })
      return response
    } catch (error) {
      console.error('Ошибка получения раунда Royale по ID:', error)
      throw error
    }
  },

  /**
   * Получить историю всех раундов
   * GET /api/classic/history/
   */
  getHistoryAll: async () => {
    try {
      const response = await apiService.makeRequest('/api/classic/history/', {
        method: 'GET'
      })
      return response
    } catch (error) {
      console.error('Ошибка получения истории Royale:', error)
      throw error
    }
  },

  /**
   * Получить историю моих раундов
   * GET /api/classic/history/me/
   */
  getHistoryMine: async () => {
    try {
      const response = await apiService.makeRequest('/api/classic/history/me/', {
        method: 'GET'
      })
      return response
    } catch (error) {
      console.error('Ошибка получения истории Royale (мои):', error)
      throw error
    }
  }
}

export default royaleApi
